<template>
  <div class="page-container">
    <div class="filter-container">
      <el-form :inline="true">
        <el-form-item :label="item.label" v-for="item in agentAllFilter" :key="item.label">
          <el-date-picker
            type="datetimerange"
            v-if="item.type === 'datetimerange'"
            v-model="form[item.start + '_' + item.end]"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
          ></el-date-picker>
          <el-input v-else v-model="form[item.prop]"></el-input>
        </el-form-item>
        <div class="btn-container">
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">清空</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-container">
      <el-table stripe :data="tableData">
        <el-table-column :label="item.label" v-for="item in agentAllTable" :key="item.label">
          <template slot-scope="scope">
            <span v-if="item.filter">{{ item.filter(scope.row) }}</span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"  width="320">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="false" @click="listMoneyDetails(scope.row.localId)">流水</el-button>
            <el-button type="text" size="small" style="margin-right: 20px" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="canResetPassword" @click="handleResetPasswd(scope.row.userId)"
                       style="margin-right: 20px">修改密码
            </el-button>
            <el-popover
              placement="bottom"
              width="240"
              trigger="manual"
              v-if="scope.row.enabled===1"
              v-model="scope.row.disableShow"
            >
              <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
                请输入安全密码：
                <el-input type="password" size="small" style="width: 110px" v-model="verify"></el-input>
              </div>
              <div style="display: flex;justify-content: flex-end;">
                <el-button type="text" size="small" @click="verify = '';scope.row.disableShow = false">取消</el-button>
                <el-button size="small" type="primary" @click="handleStatus(scope.row.localId, 2)">确定</el-button>
              </div>
              <el-button type="text" size="small" slot="reference" style="margin-right: 20px"
                         @click="scope.row.disableShow=true">冻结
              </el-button>
            </el-popover>
            <el-popover
              v-else
              placement="bottom"
              width="240"
              trigger="manual"
              v-model="scope.row.enabledShow"
            >
              <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
                请输入安全密码：
                <el-input type="password" size="small" style="width: 110px" v-model="verify"></el-input>
              </div>
              <div style="display: flex;justify-content: flex-end;">
                <el-button type="text" size="small" @click="verify = '';scope.row.enabledShow = false">取消</el-button>
                <el-button size="small" type="primary" @click="handleStatus(scope.row.localId, 1)">确定</el-button>
              </div>
              <el-button type="text" size="small" slot="reference" style="margin-right: 20px"
                         @click="scope.row.enabledShow=true">解冻
              </el-button>
            </el-popover>
            <el-popover
              placement="bottom"
              width="240"
              trigger="manual"
              v-model="scope.row.visible"
            >
              <div style="display: flex;font-size: 12px;align-items: center;margin-bottom: 10px;">
                请输入安全密码：
                <el-input type="password" size="small" style="width: 110px" v-model="verify"></el-input>
              </div>
              <div style="display: flex;justify-content: flex-end;">
                <el-button type="text" size="small" @click="verify = '';scope.row.visible = false">取消</el-button>
                <el-button size="small" type="primary" @click="handleDel(scope.row, scope.$index)">确定</el-button>
              </div>
              <el-button slot="reference" type="text" size="small" @click="scope.row.visible = true">删除</el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :page-count="pageCount"
        :total="pageTotal"
        @current-change="onPageChange"></el-pagination>
    </div>

    <el-dialog title="重置密码" :visible.sync="dialogResetPassword" center>
      <el-form :inline="true">
        <el-form-item prop="verify" label="安全密码">
          <el-input v-model="verify" placeholder="请输入安全密码"></el-input>
        </el-form-item>
        <el-form-item prop="pass"
                      :rules="[{ pattern: /^(\w){6,18}$/, message: '请输入正确密码（6-18位,字母,数字,下划线）', trigger: 'blur'  }]"
                      label="新密码">
          <el-input v-model="pass" min="6" max="18" placeholder="(6-18位,字母,数字,下划线)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResetPassword = false">取 消</el-button>
        <el-button type="primary" @click="doResetPasswd()">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer custom-clas="money-detail-drawer"
      :visible.sync="moneyDetails.visible"
      :with-header="false" size="50%">
      <div style="background-color: #222933;display: flex;  flex-direction: column;  height: 100vh;">
        <div style="padding: 20px;">
          <div style="font-size: x-large;">
            {{moneyDetails.title}}
          </div>
          <el-divider/>
          <div style="margin-right: 10px;text-align: right;font-size: larger;">
            <span>
              <i class="el-icon-money"/>
              现金余额:￥
              {{moneyDetails.moneySum}}
            </span>
            <span style="margin-left: 30px;">
              <i class="el-icon-bank-card"/>
              代金券余额:￥
              {{moneyDetails.vouchersSum}}
            </span>
            <el-button type="info" icon="el-icon-edit" circle size="mini" @click="popChangeMoney(moneyDetails.localId)" style="margin-left: 30px;"/>
            <el-button type="info" icon="el-icon-download" circle size="mini" @click="exportDetailExcel(moneyDetails)"/>
          </div>
        </div>
        <div style="overflow-y: auto;flex:1">
          <el-table stripe
                    :data="moneyDetails.tableData">
            <el-table-column prop="index"        label=""  width="64">
              <template slot-scope="scope">
                <el-avatar :size="32" shape="square">{{scope.row.index}}</el-avatar>
              </template>
            </el-table-column>
            <el-table-column prop="date"        label="时间"  width="150"/>
            <el-table-column prop="moneyType"   label="币种"  width="60"/>
            <el-table-column prop="delta"       label="金额"  width="80"/>
            <el-table-column prop="sum"         label="余额"  width="80"/>
            <el-table-column prop="purpose"     label="事由"  width="100"/>
            <el-table-column prop="operator"    label="操作人"  width="80"/>
            <el-table-column prop="description" label="详情"/>
            <el-table-column label="凭证" >
              <template slot-scope="scope">
                <div style="display: flex; flex-wrap: nowrap; ">
                <el-image v-for="image in scope.row.images" :key="image"
                  style="width: 64px; height: 64px;margin-right: 5px;"
                          fit="contain"
                  :src="image"
                  :preview-src-list="scope.row.images">
                </el-image>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="账户资金维护" :visible.sync="moneyOperate.visible" center width="870px">
      <el-form label-width="100px">
        <el-form-item label="代理商名称">
          <el-input v-model="moneyOperate.agentName" readonly></el-input>
        </el-form-item>
        <el-form-item label="账户">
          <el-radio-group v-model="moneyOperate.accountSelect">
            <el-radio :label="2">现金账户(当前余额:￥{{moneyOperate.moneySum.toFixed(2)}})</el-radio>
            <el-radio :label="1">代金券账户(当前余额:￥{{moneyOperate.vouchersSum.toFixed(2)}})</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额增减">
          <el-input v-model="moneyOperate.deltaMoney" placeholder="输入需要增减的金额,请注意正负号"></el-input>
        </el-form-item>
        <el-form-item label="事由">
          <el-select v-model="moneyOperate.purpose" placeholder="" @change="onMoneyOperateTypeChange">
            <el-option key="充值" label="充值" value="充值"/>
            <el-option key="消费" label="消费" value="消费"/>
            <el-option key="赠送" label="赠送" value="赠送"/>
            <el-option key="其他" label="其他" value="其他"/>
          </el-select>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input v-model="moneyOperate.description" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="财务密码">
          <el-input v-model="moneyOperate.verify" placeholder="请输入财务密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="上传凭证">
          <FileUploader bucket="dppublic" acceptFileType="image/*" ref="imgUploader1" title="凭证截图1" pathName="settlement-images" @success="onUploadImageSuccess" @deleted="onImageDelected" />
          <FileUploader bucket="dppublic" acceptFileType="image/*" ref="imgUploader2" title="凭证截图2" pathName="settlement-images" @success="onUploadImageSuccess" @deleted="onImageDelected" />
          <FileUploader bucket="dppublic" acceptFileType="image/*" ref="imgUploader3" title="凭证截图3" pathName="settlement-images" @success="onUploadImageSuccess" @deleted="onImageDelected" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="!canSubmitMoneyChange" style="min-width: 100%;" @click="submitMoneyChange">提交</el-button>
      </span>
    </el-dialog>

  </div>

</template>
<script>
import * as R from 'ramda';
import moment from 'moment';
import * as XLSX from 'xlsx';
import {login as loginApi, task as taskApi} from '@/api';
import {isAdmin} from '@/utils';
import {mapState} from 'vuex';
import FileUploader from '@/comp/FileUploader';

export default {
  name: 'AgentManage',
  data() {
    return {
      agentAllFilter: [],
      agentAllTable: [],

      form: {},

      verify: '',
      canResetPassword: false,
      dialogResetPassword: false,
      id: '',
      pass: '',
      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,

      tableData: [],

      // options
      options: {
        itemNamesOptions: [],
      },

      moneyDetails: {
        visible: false,
        title: '',
        description: '',
        localId: null,
        tableData: []
      },
      moneyOperate: {
        visible: false,
        localId: null,
        agentName: 'xxxx',
        moneySum: -1,
        vouchersSum: -2,
        accountSelect: '',
        purpose: '',
        description: '',
        deltaMoney: null,
        verify: '',
        images: new Map(),
        imagesCount: 0
      }
    };
  },
  components: {
    FileUploader,
  },
  computed: {
    ...mapState('common', ['userInfo']),
    operates: ({$route}) => $route.meta.operates,
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    canSubmitMoneyChange() {
      return this.moneyOperate.purpose &&
        this.moneyOperate.description &&
        this.moneyOperate.verify &&
        !isNaN(parseInt(this.moneyOperate.accountSelect)) &&
        !isNaN(parseFloat(this.moneyOperate.deltaMoney)) &&
        this.moneyOperate.imagesCount > 0;
    }
  },
  methods: {
    handleDel(row, index) {
      if (!this.verify) {
        this.$message.error('请输入安全密码！');
        return;
      }
      taskApi.agentDelete({
        localId: row.localId,
        verify: this.verify
      })
        .then(res => {
          if (res.code === 10000) {
            this.$message.success('删除成功！');
            this.verify = '';
            this.$set(this.tableData[index], 'visible', false);
            this.onSearch();
          }
        });
    },
    handleEdit(row) {
      this.$router.push({
        path: `/account/agent/edit/${row.localId}`
      });
    },
    async lazyLoad(node, resolve) {
      const {data} = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(data.map(e => ({
        value: e.code,
        label: e.name,
        leaf: e.level >= 2
      })));
    },
    handleStatus(localId, status) {
      if (!this.verify) {
        this.$message.error('请输入安全密码！');
        return;
      }
      taskApi.agentDisable({
        localId,
        verify: this.verify,
        status
      })
        .then((res) => {
          if (res.code === 10000) {
            if (status === 1) {
              this.$message.success('解冻代理商账号成功！');
            } else {
              this.$message.success('冻结代理商账号成功！');
            }
            this.onSearch();
          }
        });
    },
    getForm() {
      const {agentAllFilter} = this.$route.meta;
      const form = {};
      R.forEach(({type, prop, start, end}) => {
        form[prop] = '';
      }, agentAllFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const {onClick} = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const {agentAllFilter, agentAllTable} = this.$route.meta;
      this.agentAllFilter = agentAllFilter;
      this.agentAllTable = agentAllTable;
      this.getForm();
      this.query();
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          taskApi.agentAdd(this.ruleForm)
            .then(res => {
              console.log(res);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancle() {
      this.resetForm('ruleForm');
      this.visible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async query(pageNo = 1) {
      const {fetchDataName} = this.$route.meta;
      this.pageNo = pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (!value) return;
        const filterItem = R.find(R.propEq('prop', key), this.agentAllFilter) || {};
        if (/_/.test(key)) { // 是 datetimerange
          if (R.isEmpty(value)) return;
          console.log(key);
          const [startKey, endKey] = key.split('_');
          const [startValue, endValue] = value;
          submitForm[startKey] = moment(startValue).format('YYYY-MM-DD HH:mm:ss');
          submitForm[endKey] = moment(endValue).format('YYYY-MM-DD HH:mm:ss');
        } else {
          submitForm[key] = filterItem.dataType === 'number' ? Number(value) : String(value);
        }
      }, this.form);
      // console.log(this.form, submitForm);
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;

      let isEmpty = true;
      const formKeys = R.keys(this.form);
      R.forEach((key) => {
        const value = this.form[key];
        if (
          (R.is(Array, value) && !R.isEmpty(value)) ||
          (R.is(String, value) && (value !== '')) ||
          (R.is(Number, value))
        ) {
          isEmpty = false;
        }
      }, formKeys);
      let rq;
      if (isEmpty) {
        rq = taskApi[fetchDataName];
      } else {
        rq = taskApi['agentList'];
        const {status} = this.$route.meta;
        if (!R.isNil(status)) {
          submitForm.status = status;
        }
      }
      const res = await rq(submitForm);
      if (res.code === 10000) {
        const {pageCount, data, count} = res.data;
        this.pageCount = pageCount;
        this.pageTotal = count;
        this.tableData = data;
      }
    },

    /**
     * 修改密码
     */
    handleResetPasswd(id) {
      this.id = id;
      this.dialogResetPassword = true;
    },
    async doResetPasswd() {
      const res = await loginApi.resetPassword({id: this.id, pass: this.pass, verify: this.verify});
      if (res.code === 10000) {
        this.dialogResetPassword = false;
        this.$message.success('修改成功！');
      }
    },
    // 查看资金详情
    listMoneyDetails(localId) {
      this.moneyDetails.visible = false;
      this.moneyDetails.localId = localId;
      this.moneyDetails.title = '';
      this.moneyDetails.tableData.length = 0;

      taskApi.agentDetail({local_id: localId}).then(res => {
        if (res.code === 10000) {
          this.moneyDetails.title = res.data.agentName;
          this.moneyDetails.moneySum = res.data.moneySum;
          this.moneyDetails.vouchersSum = res.data.vouchersSum;
        }
      });
      taskApi.agentMoneyDetails({local_id: localId}).then(res => {
        if (res.code === 10000) {
          let tableData = res.data.map((r, index) => {
            const dateObj = new Date(r.createTime);
            let moneyType = Math.abs(r.moneyDelta) > 0 ? 1 : 0;
            let delta = moneyType > 0 ? r.moneyDelta : r.vouchersDelta;
            delta = (delta > 0 ? '+' : '') + delta.toFixed(2);
            let sum = (moneyType > 0 ? r.moneySum : r.vouchersSum).toFixed(2);
            return {
              index: res.data.length - index,
              date: dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString(),
              moneyType: moneyType > 0 ? '现金' : '代金',
              delta,
              sum,
              purpose: r.purpose,
              description: r.description,
              operator: r.operator || '',
              moneySum: r.moneySum,
              vouchersSum: r.vouchersSum,
              images: r.images ? (
                r.images.split(',').map(url => {
                  return 'https://s3.truesight.com.cn/' + url.trim();
                })
              ) : []
            };
          });
          for (let d of tableData) {
            this.moneyDetails.tableData.push(d);
          }
          this.moneyDetails.visible = true;
        }
      });
    },
    onMoneyOperateTypeChange() {
      let deltaMoney = parseFloat(this.moneyOperate.deltaMoney);
      if (isNaN(deltaMoney)) {
        return;
      }
      switch (this.moneyOperate.purpose) {
        case '充值':
        case '赠送':
          this.moneyOperate.deltaMoney = Math.abs(deltaMoney);
          break;
        case '消费':
          this.moneyOperate.deltaMoney = -Math.abs(deltaMoney);
          break;
      }
    },
    // 弹窗修改资金余额
    popChangeMoney(localId) {
      this.moneyOperate.visible = false;
      this.moneyOperate.localId = localId;
      this.moneyOperate.agentName = '';
      this.moneyOperate.moneySum = 0;
      this.moneyOperate.vouchersSum = 0;
      this.moneyOperate.accountSelect = '';
      this.moneyOperate.purpose = '';
      this.moneyOperate.description = '';
      this.moneyOperate.deltaMoney = '';
      this.moneyOperate.verify = '';

      taskApi.agentDetail({local_id: localId}).then(res => {
        if (res.code === 10000) {
          this.moneyOperate.agentName = res.data.agentName;
          this.moneyOperate.moneySum = res.data.moneySum;
          this.moneyOperate.vouchersSum = res.data.vouchersSum;
          this.moneyOperate.visible = true;
        }
      });
    },
    // 提交修改资金余额
    submitMoneyChange() {
      const images = Array.from(this.moneyOperate.images.keys()).join(',');
      taskApi.agentMoneyChange({
        local_id: this.moneyOperate.localId,
        moneyType: this.moneyOperate.accountSelect,
        money: this.moneyOperate.deltaMoney,
        purpose: this.moneyOperate.purpose,
        description: this.moneyOperate.description,
        verify: this.moneyOperate.verify,
        images: images
      }).then(res => {
        if (res.code === 10000) {
          this.moneyOperate.visible = false;
          if (this.moneyDetails.visible) {
            this.listMoneyDetails(this.moneyOperate.localId);
            this.onSearch();
          }
        }
      });
    },
    // 导出余额的详情excel文件
    exportDetailExcel(moneyDetail) {
      console.log(moneyDetail);
      var wb = XLSX.utils.book_new();
      let data = moneyDetail.tableData.slice().reverse().map(item => {
        return {
          '时间': item.date,
          '现金余额': item.moneySum,
          '代金余额': item.vouchersSum,
          '交易币种': item.moneyType,
          '交易金额': item.delta,
          '事由': item.purpose,
          '详情': item.description,
        };
      });
      var ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
      XLSX.writeFile(wb, moneyDetail.title + '的资金流水 ' + moment().format('YYYY-MM-DD HH-mm-ss') + '.xlsx');
    },
    onUploadImageSuccess({paths}) {
      this.moneyOperate.images.set(R.head(paths), 1);
      this.moneyOperate.imagesCount = Array.from(this.moneyOperate.images.keys()).length;
    },
    onImageDelected({path}) {
      this.moneyOperate.images.delete(path);
      this.moneyOperate.imagesCount = Array.from(this.moneyOperate.images.keys()).length;
    },
  },
  created() {
    this.onCreated();
    if (this.isAdmin) {
      this.canResetPassword = true;
    }
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/AgentManage/index.vue